export enum GoToastStatusType {
	SUCCESS = 'success',
	WARNING = 'warning',
	ERROR = 'error',
}
